import { render, staticRenderFns } from "./CadastroPessoaJuridica.vue?vue&type=template&id=6ef76450&scoped=true"
import script from "./CadastroPessoaJuridica.vue?vue&type=script&lang=js"
export * from "./CadastroPessoaJuridica.vue?vue&type=script&lang=js"
import style0 from "./CadastroPessoaJuridica.vue?vue&type=style&index=0&id=6ef76450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef76450",
  null
  
)

export default component.exports